import { InboxOutlined } from '@ant-design/icons';
import { Button, Form, Upload } from 'antd';
import { useState } from 'react';
import { Integration } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';

export function ExecuteWithFilePage(props: { integration?: Integration; onComplete: () => void }) {
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<any>();

  const { Dragger } = Upload;

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    setUploadedFile(e.file.originFileObj);
    return e && e.fileList;
  };

  const dummyUploadRequest = ({ onSuccess }: any) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onFinish = () => {
    setLoading(true);

    var formData = new FormData();
    formData.append('file', uploadedFile);

    apiClient
      .post(`integrations/${props.integration?.id}/execute/file`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        props.onComplete();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form name="basic" onFinish={onFinish}>
      <Form.Item
        name="dragger"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        noStyle
        rules={[{ required: true, message: 'Zorunlu alan' }]}
      >
        <Dragger name="files" maxCount={1} customRequest={dummyUploadRequest} accept=".xls,.xlsx">
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Bir dosya sürükleyin veya tıklayın</p>
          <p className="ant-upload-hint">Lütfen xls veya xlsx uzantılı bir Microsoft Excel dosyası yükleyin.</p>
        </Dragger>
      </Form.Item>
      <Form.Item style={{ marginTop: '2rem', textAlign: 'center' }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
